/**
 * Checkbox
 */
import React, { useState, useEffect, useRef } from 'react';
import { useFieldValidation } from '../hooks/useFieldValidation';
import { useFormValue } from '../context/Form.context';
import CheckboxBase from './Checkbox.base';
/**
 * Checks if the checkbox should be checked.
 */
var shouldBeChecked = function (value, defaultValue) {
    if (Array.isArray(defaultValue)) {
        return defaultValue.indexOf(value) !== -1;
    }
    else {
        return value === defaultValue;
    }
};
var Checkbox = function (props) {
    var id = props.id, name = props.name, onFieldChange = props.onFieldChange, autoSubmit = props.autoSubmit, value = props.value, single = props.single, showError = props.showError, className = props.className, visibleFields = props.visibleFields, disabled = props.disabled, index = props.index, children = props.children;
    var _a = useState(shouldBeChecked(props.value, props.defaultValue)), checked = _a[0], setChecked = _a[1];
    var _b = useFormValue(), invalidFields = _b[0].invalidFields, dispatch = _b[1];
    var _c = useState(false), valid = _c[0], setValid = _c[1];
    var _d = useState(false), touched = _d[0], setTouched = _d[1];
    var fieldRef = useRef(null);
    var _e = useFieldValidation(fieldRef, props), validateField = _e[0], showFieldError = _e[1], hideFieldError = _e[2];
    useEffect(function () {
        if (single) {
            var validatedField = validateField(checked);
            if (validatedField.message) {
                setValid(false);
                dispatch({ type: 'FIELD_INVALID', field: validatedField });
            }
            else {
                setValid(true);
                if (invalidFields.includes(validatedField.id)) {
                    dispatch({ type: 'FIELD_VALID', field: validatedField });
                }
            }
            if (touched && !valid) {
                showFieldError(validatedField);
            }
            else if ((showError && !valid && visibleFields && visibleFields.includes(id)) ||
                (showError && !valid && !visibleFields)) {
                setTouched(true);
                showFieldError(validatedField);
            }
            else {
                hideFieldError();
            }
        }
    }, [touched, showError, invalidFields, visibleFields, checked]);
    var onChange = function (e) {
        var target = e.target;
        setChecked(target.checked);
        if (!touched) {
            setTouched(true);
        }
        onFieldChange({
            name: name,
            value: target.value,
            checked: target.checked,
            autoSubmit: autoSubmit,
            type: 'Checkbox',
        });
    };
    return (React.createElement(CheckboxBase, { id: index || index === 0 ? id + "-" + index : id, name: name, value: value, className: className, disabled: disabled, checked: checked, fieldRef: fieldRef, ariaDescribedby: "form" + id + "__desc", ariaInvalid: single ? !valid : undefined, onChange: onChange }, children));
};
export default Checkbox;
